import config from 'message-control/config'

const apiHost = `${config.apiHost}/oem-crm_new_java`

export default {
    getList: {
        url: `${apiHost}/api/customer-service/kpi/statistics`,
        type: 'GET',
    },
    getExport: {
        url: `${apiHost}/api/customer-service/kpi/statistics/export`,
        type: 'GET',
    },
    getUpdateTime: {
        url: `${apiHost}/api/customer-service/kpi/statistics/update-time`,
        type: 'GET',
    },
}
